import { render } from "./rbqm_dashboard.vue?vue&type=template&id=499446a8&scoped=true"
import script from "./rbqm_dashboard.js?vue&type=script&lang=js"
export * from "./rbqm_dashboard.js?vue&type=script&lang=js"

import "./rbqm_dashboard.vue?vue&type=style&index=0&id=499446a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499446a8"]])

export default __exports__